import React from 'react';
import PropTypes from 'prop-types';
import bowser from 'yola-bowser';

const PositioningAlignment = ({ scrollPosition, x = null, y = null }) => (
  <>
    {typeof y === 'number' && (
      <div
        style={{
          position: 'absolute',
          top: (bowser.ios ? 0 : scrollPosition) + y,
          bottom: 0,
          left: 0,
          right: 0,
          height: '1px',
          backgroundColor: 'var(--danger-700)',
        }}
      />
    )}

    {typeof x === 'number' && (
      <div
        style={{
          position: 'absolute',
          top: scrollPosition,
          height: '100%',
          bottom: 0,
          left: x,
          width: '1px',
          backgroundColor: 'var(--danger-700)',
        }}
      />
    )}
  </>
);

PositioningAlignment.propTypes = {
  scrollPosition: PropTypes.number.isRequired,
  x: PropTypes.number,
  y: PropTypes.number,
};

export default PositioningAlignment;
